import { init, register } from 'svelte-i18n';

// Default bahasa
const defaultLocale = 'en';

// Ambil bahasa yang tersimpan di localStorage (jika ada)
const savedLocale = typeof window !== 'undefined' && localStorage.getItem('locale');

// Inisialisasi svelte-i18n
init({
    fallbackLocale: defaultLocale,
    initialLocale: savedLocale || defaultLocale,
});

// Daftarkan file bahasa
register('en', () => import('../../lang/en.json'));
register('id', () => import('../../lang/id.json'));
// Fungsi untuk mengganti bahasa
/**
 * @param {string} locale
 */
export function setLanguage(locale) {
    if (typeof window !== 'undefined') {
        localStorage.setItem('locale', locale); // Simpan pilihan bahasa ke localStorage
    }
    init({
        initialLocale: locale,
        fallbackLocale: ''
    }); // Ubah bahasa saat ini
}
